






import Vue from 'vue'
import style from './style.module.scss'
import props from './props'

import buttonCommon from './button.vue'

export default Vue.extend({
name: 'button-attach',
  components: {
    buttonCommon
  },
  props: {
    ...props as PropsObject
  },
  data() {
    return {
      s: style
    }
  },
})
